// extracted by mini-css-extract-plugin
export default {"departments":"eF-z","departmentHeading":"fF-z","departmentSection":"gF-z","departmentName":"hF-z","departmentLink":"iF-z","expandIcon":"jF-z"};